import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';
import SignatureCanvas from 'react-signature-canvas';

const SignatureDialog = ({ open, onClose, onSave, signaturePadRef }) => {
  const handleClear = () => {
    if (signaturePadRef.current) {
      signaturePadRef.current.clear();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ bgcolor: '#008080', color: 'white', fontWeight: 'bold' }}>
        Provide Signature
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Box sx={{ border: '2px dashed #008080', borderRadius: 2, bgcolor: '#f9f9f9' }}>
          <SignatureCanvas
            ref={signaturePadRef}
            canvasProps={{
              width: 500,
              height: 200,
              className: 'sigCanvas',
              style: { width: '100%', height: '200px' }
            }}
          />
        </Box>
        <Typography variant="caption" sx={{ mt: 1, display: 'block', textAlign: 'center', color: '#666' }}>
          Please sign within the box above
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2, bgcolor: '#f1f5f9' }}>
        <Button onClick={handleClear} variant="outlined" color="error">
          Clear
        </Button>
        <Button onClick={onClose} variant="text" sx={{ color: '#666' }}>
          Cancel
        </Button>
        <Button onClick={onSave} variant="contained" sx={{ bgcolor: '#008080', '&:hover': { bgcolor: '#006666' } }}>
          Save Signature
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignatureDialog;
